@let headerValue = header();
@let hasSearchValue = hasSearch();
@let searchPlaceholderValue = searchPlaceholder();
@let itemsValue = visibleItems();
@let groupedItemsValue = visibleGroupedItems();

<rt-dropdown [width]="width()">
  @if (headerValue) {
    <rt-dropdown-header>
      {{ headerValue }}
    </rt-dropdown-header>
  }

  @if (hasSearchValue) {
    <rt-dropdown-item [hasHoverEffect]="false" (click)="$event.stopPropagation()">
      <rt-form-field>
        <rt-input
          (reset)="searchControl.reset('')"
          [formControl]="searchControl"
          [hasClearButton]="true"
          [placeholder]="searchPlaceholderValue"
          variant="rounded"
        >
          <rt-icon name="search" prefix />
        </rt-input>
      </rt-form-field>
    </rt-dropdown-item>
  }

  <div #scrollWrap rtScrollable class="scroll-wrap">
    @if (itemsValue?.length) {
      @for (item of items(); track item.value) {
        <ng-container *ngTemplateOutlet="dropdownItem; context: { item }" />
      }
    } @else if (groupedItemsValue?.length) {
      @for (group of groupedItemsValue; track group.title) {
        <rt-dropdown-item
          [hasHoverEffect]="false"
          [highlighted]="true"
          [highlightColor]="'light'"
          (click)="$event.stopPropagation()"
          class="group-title"
        >
          {{ group.title }}
        </rt-dropdown-item>

        <rt-divider />

        @for (item of group.items; track item.value) {
          <ng-container *ngTemplateOutlet="dropdownItem; context: { item }" />
        }
      }
    } @else {
      <rt-dropdown-item [hasHoverEffect]="false" (click)="$event.stopPropagation()">
        {{ 'app.common.no_results_found' | translate }}
      </rt-dropdown-item>
    }
  </div>
</rt-dropdown>

<ng-template #dropdownItem let-item="item">
  <rt-dropdown-item
    [hasHoverEffect]="!item.disabled"
    [highlighted]="!item.disabled && !!item.highlighted"
    [rtTooltip]="item.tooltip"
    [rtTooltipEnabled]="!!item.tooltipEnabled"
    [rtTooltipPosition]="item.tooltipPosition ? item.tooltipPosition : 'above'"
    (click)="!item.disabled && selectionChange.emit(item.value)"
    [class.disabled]="!!item.disabled"
  >
    @if (item.icon) {
      <rt-icon
        prefix
        [name]="item.icon"
        [colorToken]="$any(item.disabled ? 'colorIconDisabled' : 'colorIconDefault')"
      />
    }
    <div layout-vertical>
      <div layout layout-align-items-center>
        {{ item.option }}
        @if (item.badgeTemplate) {
          <ng-container [ngTemplateOutlet]="item.badgeTemplate" />
        }
      </div>
      @if (item.description) {
        <div layout layout-align-items-center text-small text-color text-weight-default>
          {{ item.description }}
        </div>
      }
    </div>
  </rt-dropdown-item>
</ng-template>
